module.exports = __webpack_public_path__ + "1da78524a978c764b2f57ea1f2c262d5.svg";